import * as React from "react";
import type { SVGProps } from "react";
const SvgHeadphone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <path
      fill="#3C7DFF"
      d="M5.5 37.3c-.82 0-1.5-.68-1.5-1.5V24.4c-.1-5.42 1.92-10.54 5.68-14.38C13.44 6.2 18.48 4.1 23.9 4.1 34.98 4.1 44 13.12 44 24.2v11.4c0 .82-.68 1.5-1.5 1.5s-1.5-.68-1.5-1.5V24.2c0-9.42-7.66-17.1-17.1-17.1-4.62 0-8.9 1.78-12.08 5.02-3.2 3.26-4.9 7.6-4.82 12.24v11.42c0 .84-.66 1.52-1.5 1.52Z"
      opacity={0.4}
    />
    <path
      fill="#3C7DFF"
      d="M11.88 24.9h-.26C7.42 24.9 4 28.32 4 32.52v3.76c0 4.2 3.42 7.62 7.62 7.62h.26c4.2 0 7.62-3.42 7.62-7.62v-3.76c0-4.2-3.42-7.62-7.62-7.62ZM36.38 24.9h-.26c-4.2 0-7.62 3.42-7.62 7.62v3.76c0 4.2 3.42 7.62 7.62 7.62h.26c4.2 0 7.62-3.42 7.62-7.62v-3.76c0-4.2-3.42-7.62-7.62-7.62Z"
    />
  </svg>
);
export default SvgHeadphone;
